import { money } from '../../core/format/currency';
import { listNl } from '../../core/format/text';
import type { MarginBreakdown } from '../../core/types/margin';
type Props = {
  breakdown: MarginBreakdown;
  className?: string;
};

/** De rekensom van "wat er overblijft", regel voor regel. Lege kostenposten vallen weg. */
export function MarginLines({
  breakdown: b,
  className = ''
}: Props) {
  const rows: [string, number][] = [['Inkoop', b.purchaseCents], ['Cadeaus', b.giftCents], ['Betaalkosten', b.paymentCents], ['Verzending', b.shippingCents], ['Verpakking', b.packagingCents], ['Retourvoorziening', b.returnsCents]];
  return <div className={className} data-id="element-2911" data-mp="8vtjudlkzp4w">
      <dl className="space-y-1.5 text-[13px]" data-id="element-2912" data-mp="cxydhcc14lrj">
        <div className="flex justify-between gap-4" data-id="element-2913" data-mp="cwwy4vnzdd40">
          <dt className="text-muted" data-id="element-2914" data-mp="2tmlr52z99lfm">Omzet zonder btw</dt>
          <dd className="tabular-nums text-ink" data-id="element-2915" data-mp="2tl0vtb549ygp">{money(b.revenueNetCents)}</dd>
        </div>
        {rows.filter(([, v]) => v > 0).map(([label, v]) => <div key={label} className="flex justify-between gap-4" data-id="element-2916" data-mp="17q4jut1uy1ky">
              <dt className="text-muted" data-id="element-2917" data-mp="12q8g8ux2oc5x">{label}</dt>
              <dd className="tabular-nums text-muted" data-id="element-2918" data-mp="12rjl6y297pym">−{money(v)}</dd>
            </div>)}
        <div className="flex justify-between gap-4 border-t border-line pt-2 text-[15px]" data-id="element-2919" data-mp="1grb2p8rzbohd">
          <dt className="text-ink" data-id="element-2920" data-mp="1cnd02o3g3vjk">Wat er overblijft</dt>
          <dd className={`tabular-nums ${b.leftCents < 0 ? 'text-clay' : 'text-ink'}`} data-id="element-2921" data-mp="1qnnws7rfs4cn">
            {money(b.leftCents)}
            {b.leftPercent !== null && <span className="ml-1.5 text-[12px] text-muted" data-id="element-2922" data-mp="1lob7zhh08n7f">{b.leftPercent.toLocaleString('nl-NL')}%</span>}
          </dd>
        </div>
      </dl>
      {b.missingCost.length > 0 && <p className="mt-2 text-[12px] text-clay" data-id="element-2923" data-mp="1vfyvx8ecrm45">Zonder inkoopprijs (telt als € 0): {listNl(b.missingCost)}. Boek een inkoopfactuur.</p>}
    </div>;
}